import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {TranslationProvider} from './context/translationContext';
import NewsList from './apps/NewsList';

const newsListRoot : Element | null = document.querySelector('[data-nezzobalgristblog-newslist]');

if (newsListRoot !== null) {

    const translationScriptTag = document.querySelector('[data-nezzobalgristblog-translation]');
    const translations = JSON.parse(translationScriptTag ? translationScriptTag.innerHTML : '[]');

    const itemsScriptTag = document.querySelector('[data-nezzoprojecttemplate-news-list-items]');
    const newsList = JSON.parse(itemsScriptTag ? itemsScriptTag.innerHTML : '[]');

    ReactDOM.render(
        <TranslationProvider value={translations}>
            <NewsList itemsPerPage={newsList.itemsPerPage} items={newsList.items} />
        </TranslationProvider>,
        newsListRoot
    );

}
